<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <h1>1. 成績</h1>
                </div>
                <div><img src="/static\images\ja\newManual\achievementManual-1.png" alt="" /></div>
                <div>
                    <p>① 修了試験または中期試験完了後、[成績]ボタンをを押下すると、成績状況画面を表示されます。

</p>
                </div>
                <div><img src="/static\images\ja\newManual\achievementManual-2.png" alt="" /></div>
                <div>
                    <p>② 修了試験又は中期試験の試験結果を参照できます。</p>
                    <p>※ 受験履歴の確認について、「受験履歴」リンクをクリックしてください。</p>
                </div>
                <div>
                    <h1>2. 受験履歴</h1>
                </div>
                <div><img src="/static\images\ja\newManual\historyExamManual-1.png" alt="" /></div>
                <div>
                    <p>①  [受験履歴]リンクを押すと受験履歴画面に移動します。</p>
                </div>
                <div><img src="/static\images\ja\newManual\historyExamManual-2.png" alt="" /></div>
                <div>
                    <p>② [戻る]ボタンを押すと、直前の画面に戻ります。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <h1>1. 成績</h1>
                </div>
                <div><p>① 修了試験または中期試験完了後、[成績]アイコンをクリックすると、成績画面を表示されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\score_static_1.png" alt="" /></div>
                <div><p>② 試験の成績[試験名]、[最高点数]、[試験結果]、[テストチャート]を参照できます。</p></div>
                <div><p>● 試験名: 受験した試験の名前が表示されます。</p></div>
                <div><p>● 最高点数:試験で得点した最高得点です。</p></div>
                <div><p>● 試験結果: 試験に合格または合格した結果です。</p></div>
                <div><p>※ 試験履歴の確認方法については[試験履歴]セクションで確認できます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\score_static_2.png" alt="" /></div>
                <div>
                    <h1>2. 受験履歴</h1>
                </div>
                <div><p>① 修了試験完了後、[受験履歴]ボタンを押下すると、修了試験の成績状況画面が表示されます。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\history_score_static_1.png" alt="" /></div>
                <div><p>② [受験履歴]ボタンを押すと、修了試験の受験履歴画面に移動します。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\history_score_static_2.png" alt="" /></div>
                <div><p>③ 矢印マークをクリックすると、各コースの詳細が表示されます。</p></div>
                <div><p>● 試験を受ける時間:試験に取り組む時間。</p></div>
                <div><p>● 開始時間: 試験を受け始める時間。</p></div>
                <div><p>● 試験を終了する時間: 試験を提出する時間。</p></div>

                <div><p>● 評価:あなたが合格するかどうかを判断するためにベンチマークに対するあなたのスコアに基づいています。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\history_score_static_3.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/achievement_manual.vue